import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useQuery} from "react-query";

import {Button, Input, Select} from "../common";
import {BUTTON_TYPES, ROUTES} from "../../types";
import {AppointmentModal} from "../modal";
import {Validators} from "../../utils";

const { addSpacesForNumber } = Validators;

const CountReward = () => {
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const { data, error }:
    {
      data: { types?: Array<any>; products?: Array<any>} | undefined;
      error?: any
    } = useQuery(["calculatorData"], { refetchOnWindowFocus: false })

  const [activeProduct, setActiveProduct] = useState<{id: string; label: string} | null>(null);
  const [activeBank, setActiveBank] = useState<{id: string; label: string, reward: number | string} | null>(null);
  const [applicationNumber, setApplicationNumber] = useState<number>(0);
  const [sum, setSum] = useState<number | string>(0);
  const [filteredBanks, setFilteredBanks] = useState<Array<{id: string | number; label: string}> | []>([]);

  if (error) {
    console.log('Error: ', error);
  }

  const handleChangeProduct = (label: string) => {
    const selected = data?.types?.find(i => i.label === label);
    const filteredProducts = data?.products?.filter(i => i.type === selected.name)?.map(({ bank }, index) => ({ id: index, label: bank }));

    setFilteredBanks(filteredProducts || []);

    if (selected) {
      setActiveProduct(selected);
    }
  }

  const handleChangeBank = (idx: string) => {
    const { bank, reward } = data?.products?.[+idx];

    if (bank || reward) {
      const selectedBank = {
        id: idx,
        label: bank,
        reward
      };
      setActiveBank(selectedBank);
    }
  }

  const handleInputAmount = (num: number) => {
    setApplicationNumber(num);
  }

  const handleCloseModal = () => {
    setIsOpenModal(false);
  }

  const countSum = () => {
    if (!!applicationNumber && activeBank && activeProduct) {
      let sum = activeBank ? +activeBank?.reward * applicationNumber : 0;
      setSum(addSpacesForNumber(sum))
    }
  }

  return (
    <div className="max-w-[1720px] mx-auto flex items-center justify-center relative mx-auto mt-[160px] w-full min-h-[484px] bg-backgroundImage after:content-[''] after:absolute after:block after:inset-0 after:bg-black/90 after:z-0">
      <AppointmentModal open={isOpenModal} onClose={handleCloseModal} />
      <div className="relative z-50 text-white flex items-center justify-between w-full px-5 max-w-[1320px] mx-auto lg:flex-col lg:py-8">
        <div className="w-[35%] lg:w-full">
          <p className="font-bold text-2xl leading-[29px] mb-2 lg:text-center">Спланируйте свой доход</p>
          <p className="text-sm leading-[16px] lg:text-center">Выберите любой продукт и укажите примерное количество заявок в месяц</p>
          <br/>
          <p className="text-sm leading-[16px] mb-6 lg:text-center">Зарегистрируйтесь и начните зарабатывать!</p>

          <Button title={'Стать агентом'} onClick={() => navigate(ROUTES.SIGN_UP)} type={BUTTON_TYPES.SECONDARY} className="lg:w-full" />
        </div>

        <div className="w-[55%] lg:w-full lg:mt-10">
          <div className="flex items-center gap-2 lg:flex-col mb-5 lg:mb-8">
            <div className="w-full">
              <p className="text-sm whitespace-nowrap">Выберите продукт</p>
              <Select
                onChange={(e) => handleChangeProduct(e)}
                activeData={activeProduct || {}}
                value={
                  data
                    ? data?.types?.map(({ label }) => ({ id: label, label }))
                    : []
                }
                className="w-full"
              />
            </div>

            <div className="w-full">
              <p className="text-sm whitespace-nowrap">Выберите банк</p>
              <Select
                onChange={(e) => handleChangeBank(e)}
                activeData={activeBank || {}}
                value={filteredBanks}
                className="w-full"
              />
            </div>

            <div className="w-full">
              <p className="text-sm whitespace-nowrap">Количество заявок в месяц</p>
              <Input
                onChange={(e) => handleInputAmount(+e.target.value)} defaultValue="0"
                className="w-full"
              />
            </div>
          </div>

          <Button title={'Рассчитать'} onClick={() => countSum()} type={BUTTON_TYPES.SECONDARY} className="w-full" />

          <div className="flex gap-5 mt-5 lg:mt-8">
            <p className="text-[20px] leading-[22px] font-medium text-white lg:text-[14px] whitespace-nowrap">Ваше вознаграждение</p>
            <div className="border-b border-solid border-white w-full lg:text-[14px] flex items-end justify-center">
              {sum || ''}
            </div>
          </div>

        </div>
      </div>
    </div>

  )
};

export default CountReward;
